import React from "react";
import blogImg from "./bg/Blog.png";

export const About = () => {
  return (
    <div id="blog" className="container-fluid py-5" style={{ backgroundColor: "#fff" }}>
      <div className="container">
        <div className="row align-items-center">
        <h3 className="text-center mb-4" style={{ fontWeight: "bold" }}>
          Blog
        </h3>
          {/* Blog Image */}
          <div className="col-12">
            <img 
              src={blogImg} 
              alt="Blog" 
              className="img-fluid" 
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }} 
            />
          </div>
          
        </div>
      </div>
    </div>
  );
};
